import React, { useRef, useState, useEffect } from 'react'
import { Box, IconButton, useMediaQuery, Image } from '@chakra-ui/react'
import { FaPlay, FaPause } from 'react-icons/fa'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider, { Settings } from 'react-slick'
import { useCarouselListQuery } from 'common/api/domains/goods/goodsQuery'

export default function ProductCarousel() {
  const sliderRef = useRef<Slider | null>(null)
  const [isPlaying, setIsPlaying] = useState(true)
  const [isLargerThanMd] = useMediaQuery('(min-width: 48em)')
  const [sliderHeight, setSliderHeight] = useState('300px')
  const [sliderWidth, setSliderWidth] = useState('100%')

  useEffect(() => {
    if (isLargerThanMd) {
      setSliderHeight('500px')
      setSliderWidth('100%')
    } else {
      setSliderHeight('300px')
      setSliderWidth('100%')
    }
  }, [isLargerThanMd])

  // API 데이터 조회
  const { data: cards, isLoading, error } = useCarouselListQuery(5);
  
  // 로딩 중인 경우 로딩 UI 표시
  if (isLoading) return <Box h={sliderHeight} w={sliderWidth} bg="gray.100" />;
  
  // 에러 상태 처리
  if (error) {
    console.error('캐러셀 데이터 에러:', error);
    return <Box h={sliderHeight} w={sliderWidth} bg="gray.100" />;
  }
  
  // 슬라이드가 없는 경우
  if (!cards || cards.length === 0) {
    console.log('캐러셀 데이터 없음');
    return null;
  }
  
  // 중복 슬라이드 제거 및 유효한 이미지 URL 확인
  const uniqueCards = cards
    .filter(card => card.download_url || card.url) // 유효한 이미지 URL이 있는 항목만 표시
    .filter((card, index, self) =>
      index === self.findIndex((c) => c.download_url === card.download_url)
    );
  
  console.log('중복 제거 후 슬라이드 데이터:', uniqueCards.length);

  // 슬라이더 설정
  const settings: Settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: isPlaying,
    speed: 500,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    pauseOnHover: true,
    appendDots: (dots: any) => (
      <div style={{ position: 'absolute', bottom: '10px' }}>
        <ul style={{ margin: '0px' }}>
          {dots}
          <li style={{ display: 'inline-block', margin: '0 5px' }}>
            <button
              onClick={() => setIsPlaying((prev) => !prev)}
              style={{ background: 'transparent', border: 'none', cursor: 'pointer' }}
            >
              {isPlaying ? (
                <img src="/mall1/pause.svg" alt="ЗОГСООХ" style={{ width: '12px', height: '12px' }} />
              ) : (
                <img src="/mall1/play.svg" alt="ТОГЛООХ" style={{ width: '12px', height: '12px' }} />
              )}
            </button>
          </li>
        </ul>
      </div>
    ),
    dotsClass: 'slick-dots',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false
        }
      }
    ]
  }

  return (
    <Box
      position="relative"
      width="100%"
      height={sliderHeight}
      overflow="hidden"
      mb={4}
    >
      {/* 슬라이더 */}
      <Slider {...settings} ref={(slider) => (sliderRef.current = slider)}>
        {uniqueCards.map((card: any, index: number) => {
          const imageUrl = isLargerThanMd ? card.download_url : (card.url || card.download_url);
          
          return (
            <Box 
              key={index}
              height={sliderHeight}
              width="100%"
              overflow="hidden"
              position="relative"
            >
              <Image
                src={imageUrl}
                alt={`슬라이드 ${index + 1}`}
                width="100%"
                height="100%"
                objectFit="cover"
                objectPosition="center"
                fallbackSrc="https://via.placeholder.com/1200x500?text=이미지+로드+실패"
              />
            </Box>
          );
        })}
      </Slider>
      
      {/* 화살표는 슬라이더 설정으로 처리되므로 여기서는 제거 */}
    </Box>
  )
}
